import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Chemical } from '@context/shared/types/chemical';
import { TuiSizeL, TuiSizeS } from '@taiga-ui/core';
import { TuiAvatar } from '@taiga-ui/kit';

@Component({
	imports: [TuiAvatar],
	selector: 'ctx-chemical-thumbnail',
	templateUrl: 'chemical-thumbnail.component.html',
	styleUrl: 'chemical-thumbnail.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		'[attr.size]': 'size()',
	},
})
export class ChemicalThumbnailComponent {
	readonly chemical = input.required<Chemical>();

	readonly size = input<TuiSizeS | TuiSizeL>('l');
}
